/* unplugin-vue-components disabled */import { render } from "./company-suggestion.vue?vue&type=template&id=750c9e06&scoped=true"
import script from "./company-suggestion.vue?vue&type=script&lang=js"
export * from "./company-suggestion.vue?vue&type=script&lang=js"

import "./company-suggestion.vue?vue&type=style&index=0&id=750c9e06&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750c9e06"],['__file',"src/components/search-dropdown/company-suggestion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "750c9e06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('750c9e06', __exports__)) {
    api.reload('750c9e06', __exports__)
  }
  
  module.hot.accept("./company-suggestion.vue?vue&type=template&id=750c9e06&scoped=true", () => {
    api.rerender('750c9e06', render)
  })

}


export default __exports__